"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.tokenConfigurationForTokenRoutes = exports.USER_TOKEN_STORAGE_KEY = exports.UNKNOWN_USER = exports.PUBLIC_TOKEN_USER = exports.NOT_LOGGED_IN_USER_ID = exports.NONCE_STORAGE_KEY = exports.LOGGED_IN_USER_COOKIE = exports.ID_TOKEN_STORAGE_KEY = exports.IDENTITY_CLIENT_ID = exports.CODE_VERIFIER_STORAGE_KEY = exports.AUTH_STATE_STORAGE_KEY = exports.AUTH_REDIRECT_URL_STORAGE_KEY = exports.AUTH_REDIRECT_URI_STORAGE_KEY = exports.AUTHORIZATION_CODE_STORAGE_KEY = exports.ANONYMOUS_TOKEN_STORAGE_KEY = void 0;
var _TokenEventNames = require("./TokenEventNames");
var _TokenRoutes = require("./TokenRoutes");
var _TokenSessionStorageKeys = require("./TokenSessionStorageKeys");
var AUTHORIZATION_CODE_STORAGE_KEY = exports.AUTHORIZATION_CODE_STORAGE_KEY = 'AuthCode';
// TODO: remove during refactor or major release
/**
 * @deprecated use TokenSessionStorageKeys instead
 */ var ANONYMOUS_TOKEN_STORAGE_KEY = exports.ANONYMOUS_TOKEN_STORAGE_KEY = 'PublicToken';
// TODO: remove during refactor or major release
/**
 * @deprecated use TokenSessionStorageKeys instead
 */ var USER_TOKEN_STORAGE_KEY = exports.USER_TOKEN_STORAGE_KEY = 'AuthToken';
var ID_TOKEN_STORAGE_KEY = exports.ID_TOKEN_STORAGE_KEY = 'AuthIdToken';
var AUTH_REDIRECT_URL_STORAGE_KEY = exports.AUTH_REDIRECT_URL_STORAGE_KEY = 'AuthRedirectUrl';
var AUTH_REDIRECT_URI_STORAGE_KEY = exports.AUTH_REDIRECT_URI_STORAGE_KEY = 'AuthRedirectUri';
var CODE_VERIFIER_STORAGE_KEY = exports.CODE_VERIFIER_STORAGE_KEY = 'AuthCodeVerifier';
var AUTH_STATE_STORAGE_KEY = exports.AUTH_STATE_STORAGE_KEY = 'AuthState';
var NONCE_STORAGE_KEY = exports.NONCE_STORAGE_KEY = 'AuthNonce';
/** User ID for user that is not logged in */ var NOT_LOGGED_IN_USER_ID = exports.NOT_LOGGED_IN_USER_ID = -1;
/** The name of the cookie that contains the logged in user. Coookie is used for the token validation. */ var LOGGED_IN_USER_COOKIE = exports.LOGGED_IN_USER_COOKIE = 'OriLoggedUser';
/** The `User` key value for the public token. */ var PUBLIC_TOKEN_USER = exports.PUBLIC_TOKEN_USER = 'anonymous';
/** The `User` key value if the user is unknown. */ var UNKNOWN_USER = exports.UNKNOWN_USER = 'unknown';
/**
 * Identity server client ID for authentication.
 */ var IDENTITY_CLIENT_ID = exports.IDENTITY_CLIENT_ID = 'SPADev';
var _obj;
/**
 * Token configuration under token routes. This is mainly used in TokenClient to differentiate configuration between instances by route
 */ var tokenConfigurationForTokenRoutes = exports.tokenConfigurationForTokenRoutes = (_obj = {}, _define_property(_obj, _TokenRoutes.TokenRoutes.PUBLIC_ACCESS, {
    eventName: _TokenEventNames.TokenEventNames.PUBLIC_ACCESS,
    sessionStorageKey: _TokenSessionStorageKeys.TokenSessionStorageKeys.PUBLIC_ACCESS
}), _define_property(_obj, _TokenRoutes.TokenRoutes.USER_ACCESS, {
    eventName: _TokenEventNames.TokenEventNames.USER_ACCESS,
    sessionStorageKey: _TokenSessionStorageKeys.TokenSessionStorageKeys.USER_ACCESS
}), _obj); //# sourceMappingURL=constants.js.map
